import { render, staticRenderFns } from "./ReportDetail.vue?vue&type=template&id=d6102070&scoped=true&"
import script from "./ReportDetail.vue?vue&type=script&lang=js&"
export * from "./ReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetail.vue?vue&type=style&index=0&id=d6102070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6102070",
  null
  
)

export default component.exports